export const locale = {
  GLOBAL: {
    Title: "SMS-Land",
    PostalCode: "Postleitzahl",
    postalCodes: "Postleitzahlen",
    selectedPostalCodes: "Ausgewählte Postleitzahlen",
    MciNumberCount: "Anzahl MCI-Nummern",
    MtuNumberCount: "Anzahl Irancell-Nummern",
    TotalCount: "Gesamtanzahl",
    Coefficient: "Koeffizient",
    Back: "Zurück",
  },
  ERRORS: {
    PhoneIsNotValid:
      "Die eingegebene Telefonnummer ist ungültig: Beispiel 09101234567",
    InvalidNumber: "Die eingegebene Anzahl ist ungültig",
    NoSelectedLineNumber: "Bitte wählen Sie die Absenderleitung aus.",
    EmptyText: "Bitte geben Sie eine Nachricht ein.",
    UnknownError: "Unbekannter Fehler",
    TryAgain: "Bitte versuchen Sie es später erneut.",
    NoAccountCharge: "Unzureichendes Guthaben",
    NoAccess: "Kein Zugriff.",
    PleasebyeAPlane: "Bitte kaufen Sie einen Tarif.",
    PleaseChargeYourAccount: "Bitte laden Sie Ihr Konto auf.",
    AccessDenied: "Zugriff verweigert.",
    AccessDeniedDescription:
      "Für weitere Informationen kontaktieren Sie bitte den Support",
    Error: "Fehler",
    InvalidText: "Ungültiger Text",
    InvalidTextContainsLink: "Nur Servicenummern dürfen Links enthalten.",
  },
  INFOS: {
    SuccessSentSms: "Nachricht wurde gesendet",
    SmsRequestInQueue:
      "Ihre Nachricht wird nach der Freigabe durch den Administrator gesendet",
    SendData: "Versandinformationen",
    CheckData: "Bitte lesen und bestätigen Sie die folgenden Informationen.",
  },
  TOBE: {
    to: "an ",
    from: "von ",
  },
  FORMS: {
    DestinationPhone: "Empfängernummer",
    TestDestinationPhone: "Testnummer",
    SourceNumber: "Absendernummer",
    Text: "Nachricht",
    CharCount: "Zeichenanzahl",
    FarsiCharCount: "Persische Zeichen",
    EnglishCharCount: "Englische Zeichen",
    Send: "Senden",
    SendTime: "Sendezeit",
    SendTest: "Test senden",
    SendToTestNumber: "An Testnummer senden",
    SmsCount: "Anzahl SMS",
    SmsLang: "Sprache der SMS",
    Add: "Hinzufügen",
    FromFile: "Aus Datei hinzufügen",
    TestNumber: "Testnummer",
    Test: "Test",
    ServiceRelated: "Servicenummer",
    Price: "Preis",
    NumbersCount: "Anzahl Nummern",
    NumbersCountToSend: "Anzahl Nummern, an die gesendet wird",
    Search: "Suche",
    Title: "Titel",
    RequestTime: "Anfragezeit",
    RequestInformation: "Anfrageinformationen",
    CreateNewPhoneBook: "Neues Adressbuch erstellen",
  },
  BUTTONS: {
    OK: "OK",
    AccountCharge: "Konto aufladen",
    Reports: "Berichte",
    RemoveAll: "Alle löschen",
    BuyAPlane: "Tarif kaufen",
    Accept: "Bestätigen",
    Reject: "Ablehnen",
    Yes: "Ja",
    No: "Nein",
    Create: "Erstellen",
    New: "Neu",
    Save: "Speichern",
    Delete: "Löschen",
    More: "Mehr",
    TryAgain: "Erneut versuchen",
    Close: "Schließen",
    RollBack: {
      back: "Zum vorherigen Benutzer zurückkehren",
      goToMainUser: "Zum Hauptbenutzer zurückkehren",
      CurrentUser: "Aktueller Benutzer",
    },
  },
  DIALOGS: {
    Waiting: "Bitte warten",
    RejectItQuestion: "Ablehnen?",
    AcceptItQuestion: "Bestätigen?",
    Rejected: "Abgelehnt",
    Accepted: "Bestätigt",
    Error: "Fehler",
  },
  CONFIRM: {
    Delete: "Sind Sie sicher, dass Sie löschen möchten?",
    DeleteA: "Sind Sie sicher, dass Sie {a} löschen möchten?",
    DeleteALL: "Sind Sie sicher, dass Sie alles löschen möchten?",
  },
  LANGUAGE: {
    English: "Englisch",
    Persian: "Persisch",
  },
  language: {
    selectAll: "Alle auswählen",
    lang: {
      fa: "Persisch",
      ar: "Arabisch",
      ar_ae: "Arabisch (VAE)",
      ar_iq: "Arabisch (Irak)",
      en_US: "Englisch (USA)",
      en_GB: "Englisch (UK)",
      de: "Deutsch",
      fr: "Französisch",
      zh_CN: "Vereinfachtes Chinesisch",
      zh_TW: "Traditionelles Chinesisch",
      tr: "Türkisch",
      ru: "Russisch",
      hy: "Armenisch",
    },
    only_manual_now: "Derzeit ist nur manuelle Übersetzung möglich",
    ai_coming_soon: "KI-Übersetzung wird bald aktiviert",
    got_it: "Verstanden",
    origin_language: "Ausgangssprache",
    target_languages: "Zielsprachen",
    remove_all: "Alle Sprachen entfernen",
    translation_method: "Übersetzungsmethode wählen",
    manual_translation: "Manuelle Übersetzung",
    ai_translation: "KI-Übersetzung",
    coming_soon: "Demnächst",
    source_language_updated: "Ausgangssprache aktualisiert",
    error_changing_source_language: "Fehler beim Ändern der Ausgangssprache",
    source_language_created: "Neue Ausgangssprache erstellt",
    languages_saved: "Neue Sprachen gespeichert",
    error_saving_languages: "Fehler beim Speichern der Sprachen",
    error_loading_language: "Fehler beim Laden der Sprache",
    languages_removed: "Entfernte Sprachen",
    new_languages_to_save: "Neue Sprachen zum Speichern",
    saved: "Gespeichert",
    management_langs: "Sprachverwaltung",
    add_langs: "Sprache hinzufügen",
    change_language: "Sprache ändern",
    visit_card: "Visitenkarte",
    translate_to: "Übersetzen nach",
    main_language: "Hauptsprache",
    no_languages_available: "Keine Sprachen verfügbar",
    return_to_default: "Zurück zur Standardsprache",
    translate: "Übersetzen",
    changes_pending: "Warten auf das Anwenden der Änderungen",
    apply_changes: "das Anwenden der Änderungen",
    cancel_changes: "Abbrechen",
  },

  LISTS: {
    NoData: "Keine Daten vorhanden",
    NoDataFound: "Keine Daten gefunden",
    NoDataFoundFor: "Keine Daten für {a} gefunden",
    NoPhoneNumber: "Keine Telefonnummer gefunden",
    NoPostalCode: "Keine Postleitzahl gefunden",
    AddANumber: "Fügen Sie eine Nummer hinzu",
    City: "Stadt",
    AddedBefore: "Bereits hinzugefügt",
  },
  PAGES: {
    SendSms: "SMS senden",
    MapSms: "Mit Karte senden",
    PhoneBook: "Adressbuch",
  },
  MONETARY: {
    Rial: "Rial",
  },
  HINTS: {
    SendMessageTitle:
      "Der Titel ist ein beliebiger Name. Sie können frühere Nachrichtentitel verwenden, damit der Text automatisch eingefügt wird. Der Titel wird nicht mitgesendet – er dient nur für Berichte und Vorschläge.",
    SendMessageTime:
      "Die Sendezeit ist der Zeitpunkt, an dem Ihre Nachricht in die Warteschlange gestellt wird. Beachten Sie: Ohne Administratorfreigabe wird die Nachricht nicht gesendet.",
    CreatePhoneBook:
      "Dieser Name wird beim Hinzufügen von Nummern beim SMS-Versand verwendet.",
  },
  TOASTS: {
    SuccessCreate: "Erfolgreich erstellt",
    FailedCreated: "Fehler beim Erstellen",
    SuccessDelete: "Erfolgreich gelöscht",
    FailedDelete: "Fehler beim Löschen",
    SuccessEdit: "Erfolgreich bearbeitet",
    FailedEdit: "Fehler beim Bearbeiten",
    AddedSuccess: "Erfolgreich hinzugefügt",
    AddedFailed: "Fehler beim Hinzufügen",
  },
  WALLET: {
    CustomCharge: "Wunschbetrag",
    GateWay: "Zahlungsgateway",
    Price: "Betrag",
    Details: [
      "9 % Steuer werden auf den eingegebenen Betrag hinzugerechnet.",
      "Bitte geben Sie den Betrag sorgfältig ein – der eingezahlte Betrag ist nicht erstattungsfähig.",
    ],
    noGateWay: "Für Sie ist kein Zahlungsgateway definiert.",
    PriceNotInRange: "Der Betrag muss zwischen {min} und {max} Rial liegen.",
    Pay: "Bezahlen",
    ErrorOnRedirectToGateWay: "Fehler beim Weiterleiten zum Zahlungsgateway",
    ChargeWalletButtonDescription:
      "Klicken Sie auf die + Taste, um Ihr Konto aufzuladen",
  },
  login: {
    phoneField: {
      placeholderIran: "Mit 9 beginnen (Beispiel: +98 912 345 6789)",
      placeholderDefault: "Geben Sie Ihre Telefonnummer ein",
      maxDigitsError: "Maximal {count} Ziffern erlaubt!",
      iranMustStartWith9: "Die Mobilnummer muss mit 9 beginnen (z. B. 912…)",
    },
    signup_button: "Ich melde mich an!",
    forget_password_title: "Passwort vergessen",
    register_title: "Kostenlose Registrierung",
    login_title: "Anmelden",
    back: "Zurück",
    username_label: "Mobilnummer / Benutzername",
    otp_resend_button: "Code erneut senden",
    password_label: "Passwort",
    password_hint: "Mindestens 8 Zeichen",
    name_label: "Vorname",
    name_rule: "Mindestens 3 Zeichen",
    lastname_label: "Nachname",
    phone_label: "Mobiltelefon",
    nid_label: "Personalausweisnummer",
    parent_phone_label: "Mobilnummer des Empfehlers (optional)",
    terms_and_conditions_message:
      "Die Registrierung gilt als Annahme der Nutzungsbedingungen des Werbeterminals.",
    terms_and_conditions_link: "Nutzungsbedingungen",
    close: "Schließen",
    forgot_password_link: "Passwort vergessen?",
    change_password: "Passwort ändern",
    register_button: "Registrieren",
    login_button: "Anmelden",
    login_with_google: "Mit Google anmelden",
    login_with_sms: "Mit SMS anmelden",
    login_with_password: "Mit Passwort anmelden",
    already_registered: "Bereits registriert?",
    login_here: "Anmelden",
    no_account: "Noch kein Konto?",
    signup_now: "Jetzt registrieren!",
    more_info: "Weitere Informationen",
    text_login: "Anmelden",
    text_register: "Registrieren",
    required_field: "Pflichtfeld.",
    min_8_char: "Das Feld ist kürzer als 8 Zeichen",
    required: "Dieses Feld ist erforderlich",
    min_3_char: "Mindestens 3 Zeichen",
    max_50_char: "Maximal 50 Zeichen",
    no_internet: "Sie sind nicht mit dem Internet verbunden",
    no_phone_entered: "Sie haben keine Nummer eingegeben",
    otp_sent_successfully: "Bestätigungscode erfolgreich gesendet.",
    please_register_first: "Bitte zuerst registrieren!",
    wait_3_min: "Bitte 3 Minuten warten und erneut versuchen.",
    login_successful: "Erfolgreich angemeldet",
    internet_connection_error: "Verbindungsproblem zum Internet!",
    agree_to_terms_error: "Sie haben die Nutzungsbedingungen nicht akzeptiert!",
    otp_sent_successfully_register: "Bestätigungscode erfolgreich gesendet.",
    error: "Fehler",
    registration_nid_required_notice:
      "Zur Gewährleistung höchster Sicherheit und zur Verhinderung von Betrug (Phishing) und Missbrauch ist die Angabe der Personalausweisnummer bei der Registrierung im Werbeterminal verpflichtend.",
  },
  home: {
    title: "Startseite",
    selectSystem: "System auswählen",
    yourPoints: "Ihre Punkte",
    discountCodes: "Rabattcodes",
    all: "Alle",
    discounts: "Rabatte",
    systemGuide: "Systemanleitung",
    yourPointsDynamic: "Ihre Punkte: {points}",
    confirm: "Bestätigen",
    copy: "Kopieren",
  },
  badges: {
    free: "Kostenlos",
    preRegister: "Vorregistrierung",
    comingSoon: "Demnächst",
    testVersion: "Testversion",
  },
  services: {
    qrLand: {
      title: "QR-Land System",
      description: "Dynamische QR-Codes erstellen",
      property: {
        0: "Prüfung und Auswahl von Werbeart und -ort",
        1: "Prüfung und Auswahl von Kino-Werbung",
        2: "Keine Provision oder zusätzliche Kosten",
        3: "Zentrale Verwaltung aller Kino-Werbung",
      },
    },
    payamak: {
      title: "SMS-Land System",
      description: "Massen-SMS-Werbung versenden",
      property: {
        0: "Massen-SMS-Versand",
        1: "Aktuelle Nummerndatenbank",
        2: "SMS an Kundenclub senden",
        3: "Anbindung an alle Websites und Programme",
      },
    },
    robot: {
      title: "Robot-Land System",
      description:
        "Gleichzeitige Verwaltung aller Nummern, Anzeigen und Panels",
      property: {
        0: "Gruppen- und Massenanzeigen",
        1: "Zeitgesteuerte, schrittweise und intelligente Anzeigenverwaltung",
        2: "Unbegrenzte Nummern mieten/hinzufügen",
        3: "Gleichzeitige Registrierung und Verwaltung aller Anzeigen",
      },
    },
    infoLand: {
      title: "Info-Land",
      description: "Über 2500 aktuelle Branchendatenbanken",
      property: {
        0: "Alle Branchendaten vorhanden",
        1: "Nach Städten und Provinzen kategorisiert",
        2: "Datenbank aller Berufe im Land",
        3: "Muster aller Datenbanken einsehbar",
      },
    },
    graphic: {
      title: "Grafik-Land System",
      description: "Von 0 bis 100: Grafikdesign und Video",
      property: {
        0: "Logo- und Corporate-Design",
        1: "Alle Druck- und Verpackungsdienste",
        2: "Katalog-, Broschüren- und Box-Design",
        3: "Banner-Design und -Druck in allen Größen",
      },
    },
    bestWebLand: {
      title: "Best-Web-Land System",
      description: "Webdesign, Support und SEO",
      property: {
        0: "Content-SEO",
        1: "Off-Page-SEO",
        2: "Technisches SEO",
        3: "On-Page-SEO",
      },
    },
    onlineShop: {
      title: "Online-Shop-Baukasten",
      description: "Nur wenige Klicks zur digitalen Welt",
      badge: "Affiliate-Verkauf",
      property: {
        0: "Content-SEO",
        1: "Off-Page-SEO",
        2: "Technisches SEO",
        3: "On-Page-SEO",
      },
    },
    social: {
      title: "Werbung in sozialen Netzwerken",
      description: "Prüfung und Auswahl der besten Pages & Kanäle",
      property: {
        0: "Prüfung aller reichweitenstarken Pages",
        1: "Zentrale Verwaltung aller geschalteten Werbeanzeigen",
        2: "Keine Provision oder zusätzlichen Kosten",
        3: "Online-Buchung von Werbung auf gewünschten Pages",
      },
    },
    billboard: {
      title: "Online-Billboard-Miete",
      description: "Direkt & zielgerichtet ohne Zwischenhändler",
      property: {
        0: "Prüfung von Standort und Billboard-Typ",
        1: "Verwaltung aller verfügbaren Billboards",
        2: "Direkter Kontakt zum Billboard-Eigentümer",
        3: "Keine Provision oder zusätzlichen Kosten",
      },
    },
    internationalMedia: {
      title: "Werbung in nationalen Medien",
      description: "Schaltung von Werbung im Fernsehen und Radio",
      property: {
        0: "Prüfung und Auswahl des Sendezeitraums",
        1: "Prüfung und Auswahl von TV-Werbeformaten",
        2: "Prüfung und Auswahl von Radio-Werbeformaten",
        3: "Auswahl der gewünschten TV-Sendung für die Werbung",
      },
    },
    transport: {
      title: "Werbung im ÖPNV & Verkehrsnetz",
      description: "Flughächen in Flughäfen, Bahnhöfen, Bussen & U-Bahnen",
      property: {
        0: "Prüfung und Auswahl von Werbeart und -ort",
        1: "Prüfung und Auswahl von U-Bahn-Werbung",
        2: "Keine Provision oder zusätzlichen Kosten",
        3: "Zentrale Verwaltung aller geschalteten U-Bahn-Werbungen",
      },
    },
    cinema: {
      title: "Werbung in visuellen Medien",
      description: "Kinowerbung & Video-Streaming-Plattformen",
      property: {
        0: "Prüfung und Auswahl von Werbeart und -ort",
        1: "Prüfung und Auswahl von Kinowerbeformaten",
        2: "Keine Provision oder zusätzlichen Kosten",
        3: "Zentrale Verwaltung aller Kinowerbungen",
      },
    },
    estate: {
      title: "Online-Immobilien-System",
      description: "Verwaltung von Objekten, Maklern und Kunden",
      property: {
        0: "Prüfung und Auswahl von Werbeart und -ort",
        1: "Prüfung und Auswahl von Kinowerbeformaten",
        2: "Keine Provision oder zusätzlichen Kosten",
        3: "Zentrale Verwaltung aller Kinowerbungen",
      },
    },
    AIGeneration: {
      title: "KI-System",
      description: "Bilderstellung, Chatbots",
    },
    ShortLink: {
      title: "Kurzlink-System",
      description: "Kurzlinks erstellen",
    },
    customer: {
      title: "Online-Kundenmanagementsystem",
      description: "Verwaltung, Support und Aufbau treuer Kunden",
      property: {
        0: "Prüfung und Auswahl von Werbeart und -ort",
        1: "Prüfung und Auswahl von Kinowerbeformaten",
        2: "Keine Provision oder zusätzlichen Kosten",
        3: "Zentrale Verwaltung aller Kinowerbungen",
      },
    },
    internetBroadcasting: {
      title: "Internetwerbung & Management",
      description: "Google Ads, Klick-Werbung, Advertorials",
      property: {
        0: "Prüfung und Auswahl von Werbeart und -ort",
        1: "Prüfung und Auswahl von Kinowerbeformaten",
        2: "Keine Provision oder zusätzlichen Kosten",
        3: "Zentrale Verwaltung aller Kinowerbungen",
      },
    },
    emailMarketing: {
      title: "E-Mail-Marketing-System",
      description: "Werbe-E-Mails an alle Branchen des Landes",
      property: {
        0: "Prüfung und Auswahl von Werbeart und -ort",
        1: "Prüfung und Auswahl von Kinowerbeformaten",
        2: "Keine Provision oder zusätzlichen Kosten",
        3: "Zentrale Verwaltung aller Kinowerbungen",
      },
    },
    adsOnStudium: {
      title: "Werbung in Stadien & Messen",
      description: "Präsenz Ihrer Marke in den größten Zentren",
      property: {
        0: "Prüfung und Auswahl von Werbeart und -ort",
        1: "Prüfung und Auswahl von Kinowerbeformaten",
        2: "Keine Provision oder zusätzlichen Kosten",
        3: "Zentrale Verwaltung aller Kinowerbungen",
      },
    },
    bidOnline: {
      title: "Umfassendes Online-Auktionssystem",
      description: "Auktionen erstellen oder teilnehmen",
      property: {
        0: "Prüfung und Auswahl von Werbeart und -ort",
        1: "Prüfung und Auswahl von Kinowerbeformaten",
        2: "Keine Provision oder zusätzlichen Kosten",
        3: "Zentrale Verwaltung aller Kinowerbungen",
      },
    },
    onlineTools: {
      title: "Online-Business-Tools",
      description: "Alle Hilfstools für jedes Business",
      property: {
        0: "Prüfung und Auswahl von Werbeart und -ort",
        1: "Prüfung und Auswahl von Kinowerbeformaten",
        2: "Keine Provision oder zusätzlichen Kosten",
        3: "Zentrale Verwaltung aller Kinowerbungen",
      },
    },
    onlineLearn: {
      title: "Online-Berufsbildungssystem",
      description: "Zielgerichtete Auswahl von Weiterbildungen",
      property: {
        0: "Prüfung und Auswahl von Werbeart und -ort",
        1: "Prüfung und Auswahl von Kinowerbeformaten",
        2: "Keine Provision oder zusätzlichen Kosten",
        3: "Zentrale Verwaltung aller Kinowerbungen",
      },
    },
    cloud: {
      title: "Hosting & Domainkauf",
      description: "Webhosting, Domains und Server kaufen",
      property: {
        0: "Prüfung und Auswahl von Werbeart und -ort",
        1: "Prüfung und Auswahl von Kinowerbeformaten",
        2: "Keine Provision oder zusätzlichen Kosten",
        3: "Zentrale Verwaltung aller Kinowerbungen",
      },
    },
    QrlandShop: {
  title: "Verwaltung von Online-Shops",
  description: "Zentrale Verwaltung von Produkten und Marktplätzen mit intelligenter Preisgestaltung",
  property: {
    0: "Umfassende Produktüberwachung und -verwaltung",
    1: "Verwaltung von Produktvarianten",
    2: "Überwachung und Verwaltung von Marktplätzen",
    3: "Intelligente Preisstrategien",
  },
},

  },
  "planning.title": "Planung",
  "tabs.reminder": "Erinnerungen",
  "tabs.notes": "Notizen",
  "tabs.calendar": "Kalender",
  "notes.creationDate": "Erstellungsdatum",
  "common.save": "Speichern",
  "common.cancel": "Abbrechen",
  "actions.quickActions": "Schnellaktionen",
  "notes.writeMessage": "Nachricht schreiben",
  "notes.titlePlaceholder": "Notiztitel",
  "notes.addNote": "Notiz hinzufügen",
  "notes.updatedSuccess": "Notiz erfolgreich aktualisiert.",
  "notes.addedSuccess": "Notiz erfolgreich hinzugefügt.",
  "common.deletedSuccess": "Erfolgreich gelöscht",
  "common.confirmDelete": "Sind Sie sicher, dass Sie löschen möchten?",
  "news.title": "Website-News",
  "news.noNews": "Es wurden noch keine Nachrichten veröffentlicht.",
  "news.view": "Ansehen",
  "remember.add": "Erinnerung erstellen",
  "remember.update": "Erinnerung aktualisieren",
  "remember.titleLabel": "Titel",
  "remember.dateLabel": "Erinnerungsdatum",
  "remember.confirmDelete": "Wirklich löschen?",
  "remember.deleteSuccess": "Erinnerung erfolgreich gelöscht.",
  "remember.createSuccess": "Neue Erinnerung erstellt.",
  "remember.updateSuccess": "Erinnerung aktualisiert.",
  "points.receivedAwards": "Erhaltene Prämien",
  "points.pointsHistory": "Punkteverlauf",
  "points.points": "Punkte",
  "points.discountTitle": "Robot-Land Rabatt",
  "points.discountText": "Für je 500 Punkte",
  events: {
    title: "Termine",
    addEvent: "Termin hinzufügen",
    calendar: "Basiskalender",
    close: "Schließen",
    save: "Speichern",
    update: "Aktualisieren",
    confirmDelete: "Wirklich löschen?",
    successAdd: "Erfolgreich hinzugefügt.",
    successDelete: "Termin erfolgreich gelöscht.",
    successUpdate: "Erfolgreich aktualisiert.",
    titleLabel: "Titel",
    descriptionLabel: "Beschreibung",
    colorLabel: "Farbe",
    removeAfterDrop: "Nach Loslassen entfernen",
    createEvent: "Termin erstellen",
  },
  copySuccess: "Erfolgreich kopiert.",
  copyTextTitle: "Kopieren",
  copiedTextTitle: "Kopiert",
  ribbon: {
    new: "Neu",
  },
  coupons: [
    {
      text: "Dieser Gutschein ist 3 Wochen gültig",
      title: "Einmaliger Text 20%",
    },
    {
      text: "Dieser Gutschein ist 2 Wochen gültig",
      title: "Webdesign 5%",
    },
    {
      text: "Dieser Gutschein ist nur einmal verwendbar",
      title: "Seitenmanagement 10%",
    },
    {
      text: "Dieser Gutschein wurde dauerhaft für Sie aktiviert",
      title: "Grafikdesign 5%",
    },
    {
      text: "Dieser Gutschein ist nur einmal verwendbar",
      title: "Druck 2%",
    },
  ],
  userLinks: {
    profile: {
      title: "Übersicht",
      invitation: { title: "Freunde einladen" },
      info: { title: "Persönliche Daten" },
      edit: { title: "Profil vervollständigen" },
      changePass: { title: "Passwort ändern" },
    },
  },
  profileLinks: {
    orders: "Bestellungen",
    addresses: "Adressen",
  },
  customPage: {
    overview: "Übersicht",
    personalInfo: "Persönliche Daten",
    changePassword: "Passwort ändern",
    completeProfile: "Profil vervollständigen",
    email: "E-Mail",
    balance: "Guthaben",
    phone: "Telefonnummer",
    rial: "Rial",
  },
  widget12: {
    inviteFriends: "Freunde einladen",
    viewInvitedUsers: "Liste der von Ihnen eingeladenen Nutzer anzeigen",
    yourInviteCode: "Ihr Einladungscode",
    createNewUser: "Neuen Benutzer erstellen",
    copyText: "Kopieren",
    userCreatedSuccess: "Neuer Benutzer erfolgreich erstellt",
    notCreated: "Nicht erstellt",
  },
  userInfo: {
    userInformation: "Benutzerinformationen",
    profilePicture: "Profilbild",
    allowedFileTypes: "Erlaubte Dateitypen: png, jpg, jpeg.",
    profilePictureSize: "Profilbild muss quadratisch sein (z. B. 480 × 480).",
    firstName: "Vorname",
    lastName: "Nachname",
    username: "Benutzername",
    phone: "Kontakttelefon",
    email: "E-Mail",
    receiveSMS: "SMS empfangen",
    smsCostNote:
      "Bei Aktivierung werden SMS-Kosten von Ihrem Guthaben abgezogen.",
    saveChanges: "Änderungen speichern",
    profileUpdated: "Ihr Profil wurde erfolgreich aktualisiert.",
  },
  emailSettings: {
    completeProfile: "Profil vervollständigen",
    completeProfileDesc:
      "Vervollständigung der persönlichen oder juristischen Daten",
    cancel: "Abbrechen",
    update: "Aktualisieren",
    save: "Speichern",
    selectPersonType: "Bitte wählen Sie die Personenart aus",
    realPerson: "Natürliche Person",
    legalPerson: "Juristische Person",
    phone: "Mobilnummer",
    landline: "Festnetznummer",
    fatherName: "Vatersname",
    nationalCode: "Personalausweisnummer",
    idNumber: "Ausweisnummer",
    birthday: "Geburtsdatum",
    placeOfBirth: "Geburtsort",
    postalCode: "Postleitzahl",
    email: "E-Mail",
    introduction: "Wie sind Sie auf uns gekommen?",
    nationalCodePic: "Foto des Personalausweises",
    plaque: "Hausnummer",
    address: "Vollständige Adresse",
    companyName: "Firmen-/Geschäftsname",
    registrationNumber: "Handelsregisternummer",
    economicCode: "Wirtschaftsnummer",
    organizationIdentity: "Nationale Organisationsnummer",
    companyType: "Unternehmensform",
    activity: "Tätigkeitsbereich",
    registrationAd: "Bild der Firmengründungsanzeige",
    lastPublishedAd: "Bild der letzten offiziellen veröffentlichten Anzeige",
    statute: "Bild der Satzung",
    agentLetterPic: "Bild des Vertretungsbescheids",
    successMessage: "Erfolgreich gespeichert",
    errorSelectType: "Bitte wählen Sie eine Option aus.",
    rules: {
      companyName: "Das Feld Firmen-/Geschäftsname ist Pflicht.",
      registrationNumber: "Das Feld Handelsregisternummer ist Pflicht.",
      economicCode: "Das Feld Wirtschaftsnummer ist Pflicht.",
      organizationIdentity:
        "Das Feld Nationale Organisationsnummer ist Pflicht.",
      registrationAd: "Das Bild der Firmengründungsanzeige ist Pflicht.",
      lastPublishedAd: "Das Bild der letzten offiziellen Anzeige ist Pflicht.",
      telephone: "Das Feld Festnetznummer ist Pflicht.",
      fatherName: "Das Feld Vatersname ist Pflicht.",
      nationalCode: "Das Feld Personalausweisnummer ist Pflicht.",
      birthday: "Das Feld Geburtsdatum ist Pflicht.",
      idNumber: "Das Feld Ausweisnummer ist Pflicht.",
      placeOfBirth: "Das Feld Geburtsort ist Pflicht.",
      postalCode: "Das Feld Postleitzahl ist Pflicht.",
      nationalCodePic: "Das Foto des Personalausweises ist Pflicht.",
      address: "Das Feld Adresse ist Pflicht.",
      plaque: "Das Feld Hausnummer ist Pflicht.",
    },
    companyTypes: {
      governmental: "Staatlich",
      private: "Privat",
      commonStock: "Aktiengesellschaft (börsennotiert)",
      specialStock: "GmbH / nicht börsennotiert",
    },
  },
  changePassword: {
    title: "Passwort ändern",
    description: "Ändern Sie Ihr Kontopasswort",
    cancel: "Abbrechen",
    update: "Aktualisieren",
    passwordInstructions: {
      forgotPassword:
        "Falls Sie bisher noch kein Passwort gesetzt haben, können Sie auf „Passwort vergessen“ klicken.",
      passwordRequirements:
        "Das Passwort muss mindestens 8 Zeichen lang sein und Zahlen, Groß- und Kleinbuchstaben sowie Sonderzeichen enthalten.",
      passwordPrivacy: "Bitte teilen Sie Ihr Passwort niemals mit anderen.",
      keyboardLanguage:
        "Stellen Sie beim Eingeben des Passworts sicher, dass Ihre Tastatur auf Englisch eingestellt ist.",
    },
    currentPassword: "Aktuelles Passwort",
    newPassword: "Neues Passwort",
    confirmNewPassword: "Neues Passwort wiederholen",
    addOrForgotPassword: "Passwort hinzufügen oder vergessen",
    changePasswordWithCode: "Passwort per SMS ändern",
    close: "Schließen",
    change: "Ändern",
    enterCode: "Code eingeben",
    successMessage: "Passwort erfolgreich aktualisiert",
    invalidCode: "Der eingegebene Code ist nicht korrekt.",
    tooManyAttempts: "Zu viele Versuche!",
    rules: {
      required: "Dieses Feld ist Pflicht.",
      min: "Das Feld ist kürzer als 8 Zeichen",
      equal: "Die Passwörter stimmen nicht überein",
      number: "Bitte geben Sie die Ziffern der Nummer ein",
    },
  },
  router: {
    dashboard: "Dashboard",
    contacts: "Kundenclub",
    editContact: "Kunde bearbeiten",
    createContact: "Kunde erstellen",
    customers: "Kundenliste",
    contactList: "Kontaktassistent",
    messages: "Nachrichten",
    messageCategories: "Nachrichtenkategorien",
    oldTransactions: "Alte Transaktionen",
    yourTransactions: "Ihre Transaktionen",
    buyPanel: "Panel kaufen",
    permissions: "Berechtigungen",
    createPermission: "Berechtigung erstellen",
    invitations: "Meine Einladungen",
    editUser: "Benutzer bearbeiten",
    userInformation: "Benutzerinformationen anzeigen",
    walletEdit: "Wallet-Informationen des Benutzers bearbeiten",
    userHistory: "Benutzerverlauf",
    userNotificationsHistory: "Benachrichtigungsverlauf",
    notifications: "Benachrichtigungen",
    createNotification: "Benachrichtigung erstellen",
    editNotification: "Benachrichtigung bearbeiten",
    adminNotifications: "Admin-Benachrichtigungen",
    yourNotifications: "Ihre Benachrichtigungen",
    adminNotificationsList: "Admin-Benachrichtigungen",
    tickets: "Tickets",
    createTicket: "Neues Ticket erstellen",
    editTicket: "Ticket bearbeiten",
    departments: "Abteilungen",
    createDepartment: "Neue Abteilung",
    editDepartment: "Abteilung bearbeiten",
    adminTickets: "Ticketverwaltung",
    discounts: "Rabatte",
    createDiscount: "Rabatt erstellen",
    editDiscount: "Rabatt bearbeiten",
    workReports: "Arbeitsberichte",
    createWorkReport: "Arbeitsbericht erstellen",
    callMonitoring: "Anrufüberwachung",
    adminWorkReports: "Arbeitsberichte verwalten",
    editWorkReport: "Bericht anzeigen & bearbeiten",
    packProperties: "Paketeigenschaften",
    createPackProperty: "Paketeigenschaft erstellen",
    editPackProperty: "Paketeigenschaft bearbeiten",
    panels: "Panels",
    createPanel: "Panel erstellen",
    editPanel: "Panel bearbeiten",
    transferRequests: "Auszahlungsanfragen",
    editTransferRequest: "Auszahlungsanfrage bearbeiten",
    tariffs: "Tarife",
    createTariff: "Tarif erstellen",
    editTariff: "Tarif bearbeiten",
    requests: "Anfragen",
    viewUser: "Benutzer anzeigen",
    manageTransactions: "Transaktionen verwalten",
    viewTransaction: "Transaktion anzeigen",
    manageConfigs: "Einstellungen verwalten",
    rbLandConfigs: "Robot-Land Einstellungen verwalten",
    editConfig: "Einstellungen bearbeiten",
    manageUsers: "Benutzerverwaltung",
    categories: "Kategorien",
    createCategory: "Kategorie hinzufügen",
    editCategory: "Kategorie bearbeiten",
    content: "Inhalte",
    createContent: "Inhalt erstellen",
    editContent: "Inhalt bearbeiten",
    addUserGuide: "Benutzerhandbuch hinzufügen",
    editUserGuide: "Benutzerhandbuch bearbeiten",
    roles: "Rollen",
    editRole: "Rolle bearbeiten",
    createRole: "Rolle hinzufügen",
    permissionTitle: "Berechtigungen",
    paymentGateways: "Zahlungsgateways",
    editPaymentGateway: "Zahlungsgateway bearbeiten",
    campaigns: "Kampagnen",
    createCampaign: "Kampagne erstellen",
    editCampaign: "Kampagneninformationen bearbeiten",
    adminCustomers: "Kunden",
    createCustomer: "Kunde erstellen",
    editCustomerInfo: "Kundendaten bearbeiten",
    referrerCustomers: "Empfohlene Kunden",
    customerHistory: "Kundenverlauf",
    userProfile: "Benutzerprofil",
    editProfile: "Profil bearbeiten",
    inviteFriends: "Freunde einladen",
    personalInfo: "Persönliche Daten",
    editPersonalInfo: "Daten bearbeiten",
    changePassword: "Passwort ändern",
    newWallet: "Neues Wallet",
  },
  profileView: {
    email: "E-Mail",
    balance: "Guthaben",
    personType: "Personenart",
    currency: "Rial",
    unknown: "----",
  },
  panelInfoProfile: {
    panelTitle: "Sie besitzen das {title}-Panel ({days} Tage).",
    buyOrRenew:
      "Klicken Sie auf die Schaltfläche unten, um Ihr Panel zu kaufen oder zu verlängern.",
    buyPanel: "Panel kaufen",
    percentage: "%",
  },
  profileSetting: {
    cardTitle: "Profileinstellungen",
    changePasswordTitle: "Zugangspasswort ändern",
    changePasswordSubtitle: "Ändern Sie Ihr Kontopasswort.",
    alertMessage:
      "Falls Sie bisher noch kein Passwort gesetzt haben, aktivieren Sie bitte die Option „Passwort setzen“.",
    currentPasswordLabel: "Aktuelles Passwort",
    setPasswordLabel: "Passwort setzen",
    addPassword: "Passwort hinzufügen",
    newPasswordLabel: "Neues Passwort",
    repeatPasswordLabel: "Passwort wiederholen",
    saveChanges: "Änderungen speichern",
    currentPasswordPlaceholder: "Aktuelles Passwort",
    newPasswordPlaceholder: "Neues Passwort",
    repeatPasswordPlaceholder: "Passwort wiederholen",
  },
  profileOrders: {
    cardTitle: "Bestellungen",
    openOrders: "Offene Bestellungen ({count})",
    closedOrders: "Abgeschlossene Bestellungen ({count})",
    noOrders: "Du hast bisher noch nichts bei uns bestellt",
  },
  personalInformation: {
    cardTitle: "Persönliche Kontoinformationen",
    cardSubtitle: "Aktualisiere deine persönlichen Daten.",
    cancel: "Abbrechen",
    update: "Aktualisieren",
    yourInfo: "Deine Daten",
    profilePicture: "Profilbild",
    allowedFileTypes: "Erlaubte Dateitypen: png, jpg, jpeg.",
    pictureSize: "Das Profilbild muss quadratisch sein (z. B. 480 × 480).",
    name: "Vorname",
    lastName: "Nachname",
    username: "Benutzername",
    receiveSMS: "SMS empfangen",
    smsCostNote:
      "Bei Aktivierung dieser Option werden SMS-Kosten von deinem Guthaben abgebucht.",
    phoneNumber: "Handynummer",
    phonePlaceholder: "Handynummer",
    email: "E-Mail",
    emailPlaceholder: "E-Mail",
    emailPrivacy: "Wir geben deine E-Mail-Adresse niemals an Dritte weiter.",
    successMessage: "Dein Profil wurde erfolgreich aktualisiert.",
  },
  userInfoForm: {
    companyName: "Firmen-/Geschäftsname",
    registrationNumber: "Handelsregisternummer",
    economicCode: "Wirtschaftsnummer",
    organizationIdentity: "Nationale Organisationsnummer",
    companyType: "Unternehmensform",
    activity: "Tätigkeitsbereich",
    registrationAd: "Bild der Firmengründungsanzeige",
    lastPublishedAd: "Bild der letzten offiziellen veröffentlichten Anzeige",
    statute: "Bild der Satzung",
    argentLetterPic: "Bild des Vertretungsbescheids", // Korrektur: war Tippfehler im Original
    phone: "Mobilnummer",
    telephone: "Festnetznummer",
    fatherName: "Vatersname",
    nationalCode: "Personalausweisnummer",
    id: "Ausweisnummer",
    birthday: "Geburtsdatum",
    placeBirthday: "Geburtsort",
    postalCode: "Postleitzahl",
    email: "E-Mail",
    introduction: "Wie bist du auf uns gekommen?",
    nationalCodePic: "Foto des Personalausweises",
    plaque: "Hausnummer",
    address: "Vollständige Adresse",
    companyTypes: {
      governmental: "Staatlich",
      private: "Privat",
      common_stock: "Aktiengesellschaft (börsennotiert)",
      special_stock: "GmbH / nicht börsennotiert",
    },
    rules: {
      companyName: "Das Feld Firmen-/Geschäftsname ist Pflicht.",
      registration_number: "Das Feld Handelsregisternummer ist Pflicht.",
      economic_code: "Das Feld Wirtschaftsnummer ist Pflicht.",
      organization_identity:
        "Das Feld Nationale Organisationsnummer ist Pflicht.",
      registration_ad: "Das Bild der Firmengründungsanzeige ist Pflicht.",
      last_published_ad:
        "Das Bild der letzten offiziellen Anzeige ist Pflicht.",
      telephone: "Das Feld Festnetznummer ist Pflicht.",
      fatherName: "Das Feld Vatersname ist Pflicht.",
      nationalCode: "Das Feld Personalausweisnummer ist Pflicht.",
      id: "Das Feld Ausweisnummer ist Pflicht.",
      birthday: "Das Feld Geburtsdatum ist Pflicht.",
      placeBirthday: "Das Feld Geburtsort ist Pflicht.",
      postalCode: "Das Feld Postleitzahl ist Pflicht.",
      nationalCodePic: "Das Foto des Personalausweises ist Pflicht.",
      address: "Das Feld Adresse ist Pflicht.",
      plaque: "Das Feld Hausnummer ist Pflicht.",
    },
  },
  createUserForm: {
    name: "Vorname",
    lastName: "Nachname",
    nid: "Personalausweisnummer",
    phone: "Handynummer",
    create: "Erstellen",
    errors: {
      nameRequired: "Vorname wurde nicht eingegeben!",
      lastNameRequired: "Nachname wurde nicht eingegeben!",
      nidRequired: "Personalausweisnummer wurde nicht eingegeben!",
      phoneRequired: "Handynummer wurde nicht eingegeben!",
    },
  },
  lastView: {
    cardTitle: "Deine letzten Besuche",
    cardSubtitle: "Deine letzten Seitenaufrufe",
    tableHeaders: {
      page: "Seite",
      address: "Adresse",
      enterDate: "Eintrittsdatum",
      leaveDate: "Austrittsdatum",
      timeSpent: "Verbrachte Zeit auf dieser Seite",
    },
    viewAll: "Alle anzeigen",
    timeUnit: "Minuten",
    pages: {
      home: "Startseite",
      panels: "Panels",
      profile: "Profil vervollständigen",
    },
  },
walletWidget: {
  title: "Letzte Transaktionen",
  balanceLabel: "Ihr Guthaben:",
  viewTransactions: "Transaktionen anzeigen",
  transactionTypes: {
    withdraw: "Auszahlung",
    deposit: "Einzahlung",
    charge: "Guthaben aufladen",
    refund: "Rückerstattung",
    default: "Transaktion",
    adminCharge: "Admin-Anpassung",
    agency: "Agenturprovision",
  },
},
  panelWidget: {
    title: "Du besitzt das {title}-Panel ({days}-tägig).",
    renewPrompt:
      "Klicke auf den Button unten, um dein Panel zu kaufen oder zu verlängern.",
    buyPanel: "Panel kaufen",
    percentage: "{value} %",
    infinity: "∞",
    days: "{count} Tage",
  },
  component: {
    title: "Von dir eingeladene Nutzer",
    columns: {
      row: "Nr.",
      name: "Vorname",
      family: "Nachname",
      username: "Benutzername",
      phone: "Handynummer",
      created_at: "Mitglied seit",
      actions: "Aktionen",
    },
    unknown: "Unbekannt",
    error: "Fehler",
    breadcrumb: "Eingeladene Nutzer",
  },
  table: {
    itemsPerPage: "Einträge pro Seite",
    pageText: "{0}–{1} von {2} Einträgen anzeigen",
    prevText: "Zurück",
    nextText: "Weiter",
    noDataText: "Keine Daten verfügbar",
    search: "Suche",
  },
  UserHistory: {
    title: "Nutzerhistorie",
    add_history: "Neuen Historieeintrag erstellen",
    send_message: "Nachricht senden",
    close: "Schließen",
    save: "Speichern",
    cancel: "Abbrechen",
    new_history_dialog_title: "Neuen Historieeintrag erstellen",
    send_message_dialog_title: "Nachricht senden",
    negotiations: "Geführte Verhandlungen",
    follow_up: "Themen für den nächsten Kontakt",
    success_history: "Historieeintrag erfolgreich gespeichert.",
    success_message: "Nachricht erfolgreich gesendet.",
    columns: {
      id: "ID",
      title: "Titel",
      status: "Status",
      current_time_date: "Datum letzter Kontakt",
      current_time_hour: "Uhrzeit letzter Kontakt",
      next_time_date: "Datum nächster Kontakt",
      next_time_hour: "Uhrzeit nächster Kontakt",
      user_id: "Betreuer",
      actions: "Aktionen",
    },
    table: {
      itemsPerPage: "Einträge pro Seite",
      pageText: "{0}–{1} von {2} Einträgen anzeigen",
      prevText: "Zurück",
      nextText: "Weiter",
      noDataText: "Keine Daten verfügbar",
      search: "Suche",
    },
    form: {
      title: "Titel",
      status: "Status",
      current_time: "Datum letzter Kontakt",
      description: "Beschreibung",
      next_time: "Datum nächster Kontakt",
      pursue_text: "Nachverfolgung nächster Kontakt",
      category: "Kategorie auswählen",
      message_title: "Nachrichtentitel",
    },
  },
  newUserTransactions: {
    userWallet: "Nutzer-Wallet",
    transactionList: "Transaktionsliste",
    userTransactions: "Nutzertransaktionen",
    terminal: "Terminal",
    liveSms: "Live-SMS",
    realEstateNews: "Aktuelle Divar-Angebote",
    rial: "Rial",
    row: "Nr.",
    uniqueId: "ID",
    amount: "Betrag",
    time: "Uhrzeit",
    createdAt: "Datum",
    description: "Zusätzliche Beschreibung",
    type: "Transaktionstyp",
    product_description: "Beschreibung",
    serviceId: "Service-Name",
    balanceAfter: "Guthaben danach",
    perPage: "Anzahl",
    search: "Suche",
    balance: "Guthaben",
    transactionListTooltip: "Transaktionsliste",
    panelLogin: "Zum Panel einloggen",
    history: "Historie",
    error: {
      terminalWallet: "Fehler beim Abrufen des Terminal-Wallets",
      imageLoad: "Fehler beim Laden des Bildes!",
    },
    dateFrom: "Von Datum",
    dateTo: "Bis Datum",
    oldWallet: "Altes Wallet",
    depositReceipt: "Einzahlungsbeleg",
    showReceipt: "Beleg anzeigen",
    transactionTypes: {
      online: "Online",
      admin: "Durch Admin",
      refund: "Korrekturtransaktion",
      agency: "Agentur",
      withdraw: "Auszahlung",
      deposit: "Einzahlung",
      adminCharge: "Transaktion durch Admin",
      charge: "Wallet aufladen",
      refund: "Rückerstattung",
    },
  },
  buyPanel: {
    alert: {
      choosePanel: "Bitte wähle dein gewünschtes Panel sorgfältig aus!",
    },
    dialog: {
      title: "Panel kaufen",
      confirmPurchase:
        "Bist du sicher, dass du das Panel „{title}“ kaufen möchtest?",
      discountCodeLabel: "Rabattcode",
      discountCodePlaceholder: "Gib deinen Rabattcode ein",
      applyDiscount: "Code einlösen",
      purchase: "Kaufen",
      iHaveDiscount: "Ich habe einen Rabattcode",
    },
    toast: {
      discountApplied: "Dein Rabattcode wurde erfolgreich eingelöst!",
      purchaseSuccess: "Paket erfolgreich gekauft",
      error: "Ein Fehler ist aufgetreten: {message}",
      unauthorized: "Bitte melde dich zuerst an",
      validationError: "Validierungsfehler: {message}",
    },
    currency: "Rial",
  },
  panelCard: {
    rial: "Rial",
    days: "Tage",
    buyPanel: "Panel kaufen",
  },
  cons: {
    title: "Emoji auswählen",
  },
  cons1: {
    title: "Standardtext",
  },
  MENUS: {
    AD_TERMINAL_SYSTEM: "Großes Werbe-Terminal-System",
  },
};
